import { apiCall } from "api-calls/api-call"
import {
  ClusterDetail,
  ListClustersQuery,
  ListClustersResponse,
  ListPairwiseVerdictsQuery,
  ListPairwiseVerdictsResponse,
  RejectClusterResponse,
} from "../store/types"

export const getClusters = async(query: ListClustersQuery): Promise<ListClustersResponse> => {
  return apiCall({
    method: "GET",
    path: "match-clustering/clusters",
    query,
  })
}

export const getClusterDetail = async(id: string): Promise<ClusterDetail> => {
  return apiCall({
    method: "GET",
    path: `match-clustering/clusters/${id}`,
  })
}

export const rejectCluster = async(id: string, reason: string): Promise<RejectClusterResponse> => {
  return apiCall({
    method: "POST",
    path: `match-clustering/clusters/${id}/reject`,
    body: { reason },
  })
}

export const getPairwiseVerdicts = async(
  query: ListPairwiseVerdictsQuery,
): Promise<ListPairwiseVerdictsResponse> => {
  return apiCall({
    method: "GET",
    path: "match-clustering/pairwise-verdicts",
    query,
  })
}
